var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallfooter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.806641,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#457AD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2893 14.3166L20.0879 13.7743C20.6816 13.5956 21.3199 13.6389 21.8839 13.8963C22.4479 14.1536 22.899 14.6073 23.1532 15.1727L24.4142 17.977C24.633 18.4635 24.694 19.0063 24.5886 19.5293C24.4832 20.0522 24.2166 20.529 23.8264 20.8927L21.907 22.6811C21.6498 22.9253 21.8448 23.8771 22.7845 25.5058C23.7252 27.1355 24.4522 27.7799 24.7874 27.6796L27.302 26.9108C27.8117 26.7549 28.3574 26.7624 28.8627 26.9322C29.3679 27.1021 29.8073 27.4258 30.1193 27.8579L31.9114 30.3418C32.2734 30.8434 32.441 31.4594 32.3831 32.0752C32.3252 32.691 32.0458 33.2649 31.5967 33.6903L30.2112 35.0023C29.764 35.4259 29.2124 35.7232 28.6127 35.864C28.0131 36.0048 27.3868 35.984 26.7978 35.8037C23.8951 34.9151 21.2069 32.2779 18.6969 27.9294C16.1814 23.5744 15.2315 19.901 15.8936 16.8998C16.0271 16.2951 16.3195 15.7369 16.7406 15.2829C17.1617 14.8288 17.6963 14.4952 18.2893 14.3166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallfooter);
export default __webpack_public_path__ + "static/media/callfooter.8087a14852bc2612dc1e6ae632911f14.svg";
export { ForwardRef as ReactComponent };